// The /ask/<short> deep link (#3262, founder pick 1b-A, 2026-10-06): a Short's
// end card prints stratiaadmissions.com/ask/ucla; the route opens UCLA's
// college page with Astra's sheet already open on it.
//
// /ask/* is never a page of its own: it forwards to the canonical
// /colleges/<slug> (Hosting serves the noindex app shell for /ask, and the
// college page's canonical names only its own path), so it never makes a
// duplicate of a college page. The sheet opens from the ASK_HASH.
import ASK_SHORT from '../data/askShort.json';

export const ASK_HASH = 'ask';
export const ASK_PREFIX = '/ask/';
// The utm fields kept on the forward (and sent with ask_link_landed); any
// other query parameter is dropped.
export const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign'];

const SLUGS = new Set(Object.values(ASK_SHORT));
const BY_SLUG = Object.fromEntries(Object.entries(ASK_SHORT).map(([k, v]) => [v, k]));

/** The college page slug a short name (or a full page slug) opens; null for an unknown one. */
export function resolveAsk(short) {
    const k = String(short || '').trim().toLowerCase();
    if (!k || k.length > 100) return null;
    if (Object.prototype.hasOwnProperty.call(ASK_SHORT, k)) return ASK_SHORT[k];
    return SLUGS.has(k) ? k : null;
}

/** '/ask/ucla' for a college page slug; null for a slug with no college page. */
export const askPath = (slug) => (BY_SLUG[slug] ? `${ASK_PREFIX}${BY_SLUG[slug]}` : null);

/** The utm fields of a search string, each trimmed and capped; absent ones omitted. */
export function utmOf(search) {
    let params;
    try { params = new URLSearchParams(search || ''); } catch { return {}; }
    const out = {};
    UTM_KEYS.forEach((k) => {
        const v = (params.get(k) || '').trim();
        if (v && /^[\w.-]{1,60}$/.test(v)) out[k] = v;
    });
    return out;
}

/** Where /ask/<short> forwards: the college page with the sheet's hash, its
 *  utm kept; an unknown short goes to the /colleges search for it, never to
 *  a guessed school. */
export function askDestination(short, search) {
    const slug = resolveAsk(short);
    const utm = new URLSearchParams(utmOf(search)).toString();
    if (!slug) {
        const q = String(short || '').trim().slice(0, 60);
        return { slug: null, to: q ? `/colleges?q=${encodeURIComponent(q)}` : '/colleges' };
    }
    return { slug, to: `/colleges/${slug}${utm ? `?${utm}` : ''}#${ASK_HASH}` };
}

// The bare /ask (#5267): a typed stratiaadmissions.com/ask used to fall to the
// catch-all and land a stranger on sign-in. It opens Astra on the home page
// (the #see-your-odds section), its utm kept.
export const BARE_ASK_HASH = 'see-your-odds';

/** Where the bare /ask forwards: the home page's Astra, its utm kept. */
export function bareAskDestination(search) {
    const utm = new URLSearchParams(utmOf(search)).toString();
    return { slug: null, to: `/${utm ? `?${utm}` : ''}#${BARE_ASK_HASH}` };
}
